import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
// import Http from "../../Http";
// import { Insurance_API } from "../../Helper";
import Http from "../../Http";
import { Insurance_API } from "../../Helper";
import { ShieldCheck, Clock, ArrowRight } from 'lucide-react'; // Lucide icons

import {
  AiOutlineSafety,
  AiOutlineCar,
  AiOutlinePlusCircle,
  AiOutlineFileProtect,
  AiOutlineSmile,
} from "react-icons/ai";
import {
  FaCarCrash,
  FaLock,
  FaFire,
  FaCloudSunRain,
  FaUserShield,
  FaBalanceScale,
} from "react-icons/fa";
function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const CarInsuranceNew = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [insuranceData, setInsuranceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const faqs = [
    {
      question: "What is car insurance?",
      answer:
        "Car insurance is a contract in which an insurance company agrees to cover certain costs associated with owning and driving a car. This can include coverage for accidents, theft, damage, and liability for injuries to others. It is designed to protect you from financial losses related to your vehicle.",
    },
    {
      question:
        "What factors should I consider when choosing a car insurance policy?",
      answer:
        "When selecting car insurance, consider factors like the types of coverage (liability, collision, comprehensive, etc.), deductible amounts, policy limits, and premium costs. You should also evaluate whether additional features like roadside assistance or rental car reimbursement are important to you, and check for any available discounts, such as multi-policy or safe driving discounts.",
    },
    {
      question: "Why is car insurance important?",
      answer:
        "Car insurance is important because it provides financial protection in the event of an accident, theft, or other damage to your vehicle. It also offers liability coverage to protect you from legal claims if you are responsible for injuring someone or damaging their property while driving. Without car insurance, you could face substantial financial burdens or legal consequences.",
    },
    {
      question: "Can I buy car insurance through TheFinMaster.com?",
      answer:
        "TheFinMaster.com is not a car insurance provider. We offer educational resources, policy comparison tools, and unbiased information to help you understand various car insurance options and choose the best policy for your needs. Once you have selected the right coverage, you will be directed to the insurance providers website to complete a secure application process.",
    },
    {
      question: "What is the difference between third-party and comprehensive car insurance?",
      answer:
        " Third-party insurance covers damages to other people or property caused by your car, which is mandatory by law. Comprehensive insurance covers both third-party liabilities and damages to your own vehicle due to accidents, theft, natural calamities, or fire.",
    },
    {
      question: "How is the premium for car insurance calculated?",
      answer:
        " Car insurance premiums are calculated based on factors like the car's make, model, age, location, fuel type, engine capacity, and claim history. Comprehensive policies also consider add-ons and declared insured value (IDV).",
    },
    {
      question: "What is a No Claim Bonus (NCB) in car insurance?",
      answer:
        " NCB is a reward given by insurers for not making any claims during the policy year. It translates into a discount on your renewal premium and increases with each claim-free year, up to a certain limit, making future policies more affordable.",
    },
    {
      question: "Can I transfer my car insurance when I sell my vehicle?",
      answer:
        " Yes, car insurance can be transferred to the new owner along with the vehicle. You need to notify the insurer, provide the sale documents, and request a policy transfer, which may involve an endorsement and change in ownership details.",
    },
    {
      question: "What is an IDV in car insurance?",
      answer:
        " IDV (Insured Declared Value) is the maximum amount the insurer will pay if your car is stolen or declared a total loss. It is based on the car’s current market value and decreases with depreciation each year, impacting your premium and claim amount.",
    },
    {
      question: "What documents are required to buy or renew car insurance?",
      answer:
        "To buy or renew car insurance, you typically need your car's registration certificate (RC), previous insurance details (if applicable), valid ID proof, and address proof. Some insurers may also request inspection in case of policy break.",
    },
    {
      question: "Are add-ons in car insurance worth it?",
      answer:
        " Add-ons like zero depreciation cover, roadside assistance, engine protection, and return to invoice can enhance your coverage. While they increase the premium, they offer additional peace of mind, especially for new or high-end cars.",
    },
    {
      question: "What is zero depreciation cover in car insurance?",
      answer:
        "Zero depreciation, or bumper-to-bumper cover, ensures you receive the full claim amount without any deduction for depreciation on car parts. It is ideal for new cars and helps reduce out-of-pocket expenses during repairs after an accident.",
    },
    {
      question: "Can I cancel my car insurance policy mid-term?",
      answer:
        "Yes, you can cancel your car insurance before its expiry. You must provide a valid reason and submit the required documents, like proof of new insurance or RC cancellation. Refunds are processed based on the unused policy period.",
    },
    {
      question: "How do I file a claim for car insurance?",
      answer:
        " To file a claim, contact your insurer immediately and provide details of the incident. Submit the required documents such as FIR (if needed), RC, driving license, and photos of the damage. The insurer will inspect and process your claim accordingly.",
    },
  ];

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  const featuresNew = [
    {
      icon: <AiOutlineSafety className="mx-auto text-blue-500 h-10 w-10" />,
      title: "Protect Your Finances from Heavy Losses",
      description:
        "Whether it’s an accident, theft, fire, or natural calamity, car insurance saves you from paying massive repair or replacement costs. Plus, it helps you avoid hefty traffic fines!",
    },
    {
      icon: <AiOutlineCar className="mx-auto text-blue-500 h-10 w-10" />,
      title: "Cover Third-Party Damages Hassle-Free",
      description:
        "Accidents can happen anytime. If your car damages another vehicle, property, or person, third-party insurance covers the costs, preventing legal and financial troubles.",
    },
    {
      icon: <AiOutlinePlusCircle className="mx-auto text-blue-500 h-10 w-10" />,
      title: "Enhance Coverage with Add-Ons",
      description:
        "A comprehensive policy offers extra protection with add-ons like zero depreciation, engine protection, and roadside assistance for a worry-free experience.",
    },
    {
      icon: (
        <AiOutlineFileProtect className="mx-auto text-blue-500 h-10 w-10" />
      ),
      title: "Stay Legally Compliant",
      description:
        "As per the Motor Vehicles Act, driving without at least third-party insurance can lead to fines of ₹2,000 for the first offense and ₹4,000 for repeat violations.",
    },
    {
      icon: <AiOutlineSmile className="mx-auto text-blue-500 h-10 w-10" />,
      title: "Peace of Mind Every Time You Drive",
      description:
        "Car insurance ensures that no matter what happens on the road, you have financial and legal support, allowing you to drive with confidence.",
    },
  ];

  const cardsNew = [
    {
      title: "Accidents & Collisions",
      description:
        "Covers repair costs for damages caused by road accidents or sudden collisions.",
      icon: <FaCarCrash className="text-4xl text-red-500 mb-4" />,
    },
    {
      title: "Theft Protection",
      description: "Compensates for financial losses if your car gets stolen.",
      icon: <FaLock className="text-4xl text-yellow-600 mb-4" />,
    },
    {
      title: "Fire Damage",
      description:
        "Provides coverage for accidental fires that may damage or destroy your vehicle.",
      icon: <FaFire className="text-4xl text-orange-600 mb-4" />,
    },
    {
      title: "Natural Disasters",
      description:
        "Covers damages from floods, earthquakes, storms, and other calamities.",
      icon: <FaCloudSunRain className="text-4xl text-blue-500 mb-4" />,
    },
    {
      title: "Personal Accident Cover",
      description:
        "Offers financial support in case of injury, disability, or death of the policyholder.",
      icon: <FaUserShield className="text-4xl text-green-600 mb-4" />,
    },
    {
      title: "Third-Party Liability",
      description:
        "Protects you against legal and financial responsibilities if your car damages another person’s vehicle, property, or causes injury.",
      icon: <FaBalanceScale className="text-4xl text-purple-600 mb-4" />,
    },
  ];

  const points = [
    {
      title: " ✔ Coverage Type: ",
      description: ` Decide whether you need a third-party liability plan (mandatory) or a comprehensive policy that covers own damages as well.`,
    },
    {
      title: "➕ Add-Ons & Riders:",
      description: `Enhance your coverage with add-ons like zero depreciation, engine protection, roadside assistance, and consumables cover.`,
    },
    {
      title: "🚑 Personal Accident Cover:",
      description: `Ensure your policy includes personal accident coverage for both the driver and passengers.`,
    },
    {
      title: "📊 Claim Settlement Ratio: ",
      description: `Choose an insurer with a high claim settlement ratio, indicating a reliable and hassle-free claims process.`,
    },
    {
      title: "🔧 Cashless Network Garages:",
      description: `Look for an insurer with an extensive network of garages offering cashless repair services.`,
    },
    {
      title: "💰 Premium & Deductibles: ",
      description: `Compare premium costs and deductible options to balance affordability and adequate coverage.`,
    },
    {
      title: "📜 Exclusions & Limitations: ",
      description: `Read the fine print to understand what’s not covered, avoiding surprises during claims.`,
    },
    {
      title: "🎖 No Claim Bonus (NCB):",
      description: `Check if the insurer offers an NCB discount for claim-free years and whether it’s transferable to another provider.`,
    },
    {
      title: "📝 Read Terms & Conditions Carefully: ",
      description: `Before signing any documents, ensure you thoroughly understand the terms, conditions, and exclusions of your policy.`,
    },
    {
      title: "⚙ Zero Depreciation Cover: ",
      description: `Since a car's value depreciates the moment it leaves the showroom, opting for a zero depreciation add-on ensures you get the full claim amount without factoring in depreciation losses.`,
    },
  ];
  const points2 = [
    {
      title: " ✔ Make & Model: ",
      description: `The car's brand, model, cubic capacity, and variant play a significant role in determining the insurance premium. High-end cars usually have higher premiums.`,
    },
    {
      title: "📆 Car Age & Depreciation:",
      description: `Older cars have lower Insured Declared Value (IDV) due to depreciation, reducing the premium amount, whereas newer cars attract higher premiums.`,
    },
    {
      title: "⚙ Engine Type:",
      description: `Diesel cars typically have higher insurance premiums compared to petrol variants due to increased repair and maintenance costs.`,
    },
    {
      title: "📍 Location Factor:",
      description: `Cars registered in metro cities or accident-prone areas attract higher premiums due to increased risk, while those in smaller towns or rural areas usually have lower premiums.`,
    },
    {
      title: "➕ Add-Ons & Riders:",
      description: `Choosing additional coverage such as zero depreciation, roadside assistance, and engine protection can increase the premium but offer better financial security.`,
    },
    {
      title: "🎖 No Claim Bonus (NCB): ",
      description: `If you don’t file a claim during your policy tenure, you can enjoy a discount on your premium upon renewal, which increases with every claim-free year.`,
    },
    {
      title: "💻 Online Purchase Advantage: ",
      description: `Buying car insurance online allows you to compare different plans, customize coverage, and avail of discounts, leading to cost savings and a hassle-free experience.`,
    },
  ];
  const data = [
    ["Damages/Losses to own car due to an accident", false, true, true],
    ["Damages/Losses to own car in case of fire", false, true, true],
    ["Damages/Losses to own car in case of a natural calamity", false, true, true],
    ["Damages to Third-Party Vehicle", true, true, false],
    ["Damages to Third-Party Property", true, true, false],
    ["Personal Accident Cover", true, true, false],
    ["Injuries/Death of a Third-Party Person", true, true, false],
    ["Theft of your car", false, true, true],
    ["Customize your IDV", false, true, true],
    ["Extra protection with customized add-ons", false, true, true],
  ];

  useEffect(() => {
    fetchInsuranceData();
  }, []);
  const fetchInsuranceData = async () => {
    try {
      const response = await Http.get(Insurance_API);

      // The response structure might have nested data
      // Check if response has an insurance property (like in the original fetch response)
      const data = response.insurance || response;

      // Filter the insurance data to show only Car category
      const carInsuranceData = Array.isArray(data)
        ? data.filter((insurance) => insurance.category_name === "Car")
        : [];

      setInsuranceData(carInsuranceData);
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch insurance data");
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  // const fetchInsuranceData = async () => {
  //     try {
  //         const response = await fetch('https://test.thefinmaster.com/console/react-app-directory/insurance-api.php');
  //         if (!response.ok) {
  //             throw new Error('Network response was not ok');
  //         }
  //         const data = await response.json();

  //         // Filter the insurance data to show only Car category
  //         const carInsuranceData = data.insurance.filter(insurance =>
  //             insurance.category_name === "Car"
  //         );

  //         setInsuranceData(carInsuranceData || []);
  //         setLoading(false);
  //     } catch (error) {
  //         setError('Failed to fetch insurance data');
  //         setLoading(false);
  //         console.error('Error fetching data:', error);
  //     }
  // };
  return (
    <>
      <Helmet>
        <title>
          Car Insurance Online - Buy/Renew Car Insurance Policy & Save Upto 60%
        </title>
        <meta
          name="description"
          content="Car Insurance Online - Buy/Renew Car Insurance policy from Thefinmaster at best price & save upto 60%* on four wheeler insurance policy premium."
        />
        <meta
          name="keywords"
          content="auto insurance coverages, automobile insurance companies, commercial auto insurance, icici lombard motor insurance, maruti insurance online"
        />
        <link rel="canonical" href="https://thefinmaster.com/car_insurance" />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      {/* Your existing content */}
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800 ">
              Home
            </Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>

          <li className="flex items-center">
            <span className="text-gray-500 ">Car Insurance</span>
          </li>
        </ol>
      </nav>
      <div className="w-full flex flex-col items-center">
        <div className="w-full flex justify-center">
          <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
            <div className="w-full sm:w-[50%]">
              <div className="w-[90%]">
                <h1 className="text-3xl md:text-5xl font-bold mt-6 md:mt-0 md:pl-4 pl-6">
                  <span className="text-blue-600 ">Explore Car Insurance</span>{" "}
                  Options Now!
                </h1>
                <p className="text-lg md:text-base lg:text-lg  mt-4 pl-4">
          Choose from a variety of coverage options to tailor your car insurance
          plan to your specific needs. Protect yourself from third-party
          liabilities{" "}
        </p>
                {/* <a href="#insurance_plans">
                  <button className="py-4 px-8  border rounded-full bg-blue-600 text-white shadow-lg hover:shadow-xl text-lg mt-10 font-medium">
                    See Plans
                  </button>
                </a> */}
              </div>
            </div>
            <div className="w-full sm:w-[50%]">
              <img
                className="w-full max-w-full"
                src="../assets/car1.webp"
                alt="Noimage"
              />
            </div>
          </div>
        </div>
      </div>

      {/* <div className="shadow-lg rounded-lg p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-600 flex justify-center items-center">
        <p className="text-lg md:text-base lg:text-lg text-center">
          Choose from a variety of coverage options to tailor your car insurance
          plan to your specific needs. Protect yourself from third-party
          liabilities if you cause an accident, or safeguard your own vehicle
          against damage from collisions, theft, or natural disasters. Compare
          plans, understand coverage details, and get free quotes – all in one
          place. We'll help you find the perfect car insurance plan to ensure a
          smooth ride ahead.{" "}
        </p>
      </div> */}
      {/* <div className="bg-white py-12 px-6 sm:px-12 lg:px-24 shadow-md rounded-2xl max-w-4xl mx-auto mt-10">
      <div className="text-center space-y-4">
        <h2 className="text-3xl sm:text-4xl font-bold text-gray-800">
          Estimate Your Car Insurance in Seconds
        </h2>
        <p className="text-gray-600 text-base sm:text-lg">
          Use our quick calculator to get an estimate of your car insurance premium instantly.
        </p>
        <Link
          to="/car-insurance-calculator" // Update this to your actual route
          className="inline-block mt-6 bg-blue-600 text-white text-lg px-6 py-3 rounded-full hover:bg-blue-700 transition"
        >
          Go to Calculator
        </Link>
      </div>
    </div> */}
  

      <div className="container mx-auto">
      <div className="flex flex-col lg:flex-row">
        {/* Main content area with insurance listings */}
        <div className="w-full lg:w-3/4">
          <div id="insurance_plans" className="lg:pr-6 md:px-4 px-2">
            {loading ? (
              <div className="text-center py-10">Loading insurance options...</div>
            ) : error ? (
              <div className="text-center py-10 text-red-600">{error}</div>
            ) : insuranceData.length === 0 ? (
              <div className="text-center py-10">
                No car insurance options available at the moment.
              </div>
            ) : (
              insuranceData.map((insurance) => (
                <div
                  key={insurance.id}
                  className="w-full max-w-[900px] py-2 border shadow-lg overflow-hidden hover:shadow-xl rounded-lg flex flex-wrap md:flex-nowrap gap-2 md:gap-5 justify-between mx-auto mt-4"
                >
                  <div className="flex flex-wrap md:flex-nowrap w-full justify-center items-center md:justify-normal">
                    <Link to={`/car_insurance/${insurance.page_url}`}>
                      <div className="w-[95%] md:w-[220px] overflow-hidden py-2 md:ml-2">
                        <img
                          className="w-full h-full object-contain"
                          alt={insurance.page_title || "Insurance Provider"}
                          src={insurance.image}
                        />
                      </div>
                    </Link>
                  </div>

                  <div className="w-full md:pl-0 pl-4 mt-2 md:mt-6">
                    <p className="text-gray-500 font-medium text-sm md:text-base">Premium Starting </p>
                    <h4 className="text-xl md:text-2xl py-0.5 font-bold">
                      @ ₹{insurance.premium_start}
                    </h4>
                  </div>

                  <div className="w-full md:pl-0 pl-4 mt-2 md:mt-6">
                    <p className="text-gray-500 font-medium text-sm md:text-base">Claim Settlement </p>
                    <h4 className="text-xl md:text-2xl py-0.5 font-bold">
                      {insurance.claim_settlement}%
                    </h4>
                  </div>

                  <div className="w-full md:pl-0 pl-4 mt-2 md:mt-6">
                    <p className="text-gray-500 font-medium text-sm md:text-base">Network Garages</p>
                    <h4 className="text-xl md:text-2xl py-0.5 font-bold">
                      {insurance.network_garages}+
                    </h4>
                  </div>

                  <div className="flex flex-wrap justify-center md:justify-between items-center my-3 md:my-5 w-full gap-2 px-2 md:px-4">
                    <a
                      href={insurance.bank_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <button className="bg-green-500 text-white font-semibold py-1 md:py-2 px-3 md:px-4 rounded hover:bg-green-600 transition duration-300 text-sm md:text-base">
                        Get Quote!
                      </button>
                    </a>

                    <Link to={`/car_insurance/${insurance.page_url}`}>
                      <button className="text-white font-semibold py-1 md:py-2 px-3 md:px-4 rounded hover:bg-blue-600 transition duration-300 bg-blue-500 text-sm md:text-base">
                      See Details
                      </button>
                    </Link>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>

        {/* Right side ad banner that scrolls with the page */}
        <div className="w-full lg:w-1/4 px-2 md:px-4 mt-6 lg:mt-0">
          <div className="sticky top-20">
            {/* Ad 1 - Visible on all screen sizes */}
            <a href="https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="block">
              <img 
                src="/assets/niyoo.png" 
                alt="Insurance Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a>
            
            {/* Ad 2 - Hidden on small mobile, visible on larger screens */}
            {/* <a href="https://example.com/premium-discount" target="_blank" rel="noopener noreferrer" className="hidden sm:block mt-6">
              <img 
                src="/assets/niyoo.png" 
                alt="Premium Discount Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
            
            {/* Compact ad for mobile only */}
            {/* <a href="https://example.com/mobile-offer" target="_blank" rel="noopener noreferrer" className="block sm:hidden mt-4">
              <img 
                src="/assets/niyoo.png" 
                alt="Mobile Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
          </div>
        </div>
      </div>
    </div>
      {/* <div id="insurance_plans" className="lg:px-48">
        {loading ? (
          <div className="text-center py-10">Loading insurance options...</div>
        ) : error ? (
          <div className="text-center py-10 text-red-600">{error}</div>
        ) : insuranceData.length === 0 ? (
          <div className="text-center py-10">
            No car insurance options available at the moment.
          </div>
        ) : (
          insuranceData.map((insurance) => (
            <div
              key={insurance.id}
              className="md:w-full max-w-[900px] py-2 border shadow-lg overflow-hidden hover:shadow-xl rounded-lg flex flex-wrap md:flex-nowrap gap-5 justify-between mx-auto mt-4"
            >
              <div className="flex flex-wrap md:flex-nowrap w-full justify-center items-center md:justify-normal">
                <Link to={`/car_insurance/${insurance.page_url}`}>
                  <div className="w-[95%] md:w-[220px] overflow-hidden py-2 md:ml-2">
                    <img
                      className="w-full h-full object-contain"
                      alt={insurance.page_title || "Insurance Provider"}
                      src={insurance.image}
                    />
                  </div>
                </Link>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-6">
                <p className="text-gray-500 font-medium">Premium Starting </p>
                <h4 className="text-2xl py-0.5 font-bold">
                  @ ₹{insurance.premium_start}
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-6">
                <p className="text-gray-500 font-medium">Claim Settlement </p>
                <h4 className="text-2xl py-0.5 font-bold">
                  {insurance.claim_settlement}%
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-6">
                <p className="text-gray-500 font-medium">Network Garages</p>
                <h4 className="text-2xl py-0.5 font-bold">
                  {insurance.network_garages}+
                </h4>
              </div>

              <div className="flex flex-wrap justify-center md:justify-between items-center my-5 w-full gap-2 px-4">
                <a
                  href={insurance.bank_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-green-500 text-white font-semibold py-2 px-4 rounded hover:bg-green-600 transition duration-300">
                    Get Quote!
                  </button>
                </a>

                <Link to={`/car_insurance/${insurance.page_url}`}>
                  <button className="text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-300 bg-blue-500">
                    See Details
                  </button>
                </Link>
              </div>
            </div>
          ))
        )}
      </div> */}

      <div className="flex justify-center items-center  p-4 mt-6">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center ">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
            What is a Car Insurance ?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Car insurance is a financial safety net that protects your vehicle
            from damages or losses caused by accidents, theft, fire, natural
            disasters, and third-party liabilities. It ensures both legal and
            financial security, covering repair costs and liabilities arising
            from unforeseen events. Many policies offer added benefits like
            cashless garages, 24x7 roadside assistance, and Personal Accident
            (PA) cover for injury, disability, or even death of the
            owner-driver.
          </p>
          <p className="text-gray-600 leading-relaxed mt-3">
            Having valid car insurance not only shields you from financial
            burdens but also helps avoid hefty traffic fines and legal troubles.
            You can choose from comprehensive, third-party, or own-damage
            policies based on your needs. With easy online purchasing options,
            getting car insurance is now hassle-free, ensuring peace of mind and
            seamless protection on the road.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6 text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
          Car Insurance Plans That Fit Your Needs
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2">
          Choosing the right car insurance is crucial for financial security on
          the road. Here are the three main types of car insurance plans:
        </p>

        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🚗</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Third-Party Insurance
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              A legal must-have, this covers damages to another person, vehicle,
              or property caused by your car. It ensures compliance with traffic
              laws while protecting you from hefty third-party liability costs.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🛡</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Comprehensive Insurance
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              A full-protection plan that covers both third-party liabilities
              and damages to your own car. It includes coverage for accidents,
              theft, fire, and natural calamities, making it the most
              well-rounded policy for vehicle owners.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🔒</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Own Damage Insurance
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              Designed for your vehicle’s safety, this standalone policy covers
              damages due to accidents, fire, natural disasters, and theft. It
              provides financial relief without third-party coverage.
            </p>
          </div>
        </div>
      </div>
<section className="bg-blue-50 py-6 px-4 sm:px-6 md:px-20 lg:px-20 rounded-3xl shadow-lg max-w-6xl mx-auto mt-10">
  <div className="flex flex-col md:flex-row justify-between items-center gap-10">
    {/* Left - Text and CTA */}
    <div className="max-w-xl space-y-6 text-center md:text-left">
      <h2 className="text-2xl sm:text-3xl font-bold text-blue-900 leading-tight">
        Calculate Your Car Insurance <br />
        in <span className="text-blue-600">Seconds</span>
      </h2>
      <p className="text-gray-700 text-lg">
        Use our fast and free calculator to estimate your premium — no paperwork, no waiting.
      </p>
      <Link
        to="/financial-tools-calculators/car-insurance-calculator"
        className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 text-lg rounded-full shadow-md transition"
      >
        Start Calculating <ArrowRight className="w-5 h-5" />
      </Link>
    </div>

    {/* Right - Feature List with Emojis */}
    <div className="space-y-4 text-left">
      <div className="flex items-center gap-3">
        <span className="text-xl">🛡️</span>
        <span className="text-gray-800 font-medium">Reliable & Accurate Estimates</span>
      </div>
      {[...Array(4)].map((_, i) => (
        <div key={i} className="flex items-center gap-3">
          <span className="text-xl">⏱️</span>
          <span className="text-gray-800 font-medium">Takes Less Than a Minute</span>
        </div>
      ))}
    </div>
  </div>
</section>

      <div className="max-w-7xl mx-auto px-6 py-6 text-center mt-6">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900">
          Key Statistics on Car Insurance in India
        </h2>
        <p className="text-gray-700 text-base md:text-lg mt-3 max-w-3xl mx-auto">
          Car insurance premiums in India depend on various factors like vehicle
          type, driver profile, and location. Here are some essential insights:
        </p>

        <div className="mt-8 grid md:grid-cols-3 gap-8 text-left">
          <div className="flex items-start space-x-3">
            <span className="text-orange-500 text-2xl font-bold">1</span>
            <p className="text-gray-800 text-sm md:text-base">
              <strong>Vehicle Type & Insurance Costs:</strong> Third-party
              insurance premiums range from ₹4,000 to ₹15,000 annually,
              depending on the car type. Comprehensive coverage costs between
              ₹8,000 and ₹30,000, with SUVs generally having the highest
              premiums.
            </p>
          </div>

          <div className="flex items-start space-x-3">
            <span className="text-orange-500 text-2xl font-bold">2</span>
            <p className="text-gray-800 text-sm md:text-base">
              <strong>Driver Age & Premium Variation:</strong> Younger drivers
              (under 25) pay around ₹3,273 per year. Those aged 25-50 pay
              between ₹2,500 and ₹6,300, while drivers over 50 see premiums from
              ₹3,300 to ₹8,500.
            </p>
          </div>

          <div className="flex items-start space-x-3">
            <span className="text-orange-500 text-2xl font-bold">3</span>
            <p className="text-gray-800 text-sm md:text-base">
              <strong>Gender-Based Premium Differences:</strong> Female drivers
              generally pay lower premiums. On average, women pay ₹4,000-₹7,000
              for third-party insurance, while men pay between ₹8,000 and
              ₹12,000.
            </p>
          </div>
        </div>
      </div>
      {/* <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-100 text-gray-800">
                <th className="p-3 text-left border border-gray-300"></th>
                <th className="p-3 text-center border border-gray-300 font-semibold">
                  Third-Party
                </th>
                <th className="p-3 text-center border border-gray-300 font-semibold">
                  Comprehensive
                </th>
                <th className="p-3 text-center border border-gray-300 font-semibold">
                  Own Damage
                </th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {[
                [
                  "Damages/Losses to own car due to an accident",
                  false,
                  true,
                  true,
                ],
                [
                  "Damages/Losses to own car in case of fire",
                  false,
                  true,
                  true,
                ],
                [
                  "Damages/Losses to own car in case of a natural calamity",
                  false,
                  true,
                  true,
                ],
                ["Damages to Third-Party Vehicle", true, true, false],
                ["Damages to Third-Party Property", true, true, false],
                ["Personal Accident Cover", true, true, false],
                ["Injuries/Death of a Third-Party Person", true, true, false],
                ["Theft of your car", false, true, true],
                ["Customize your IDV", false, true, true],
                ["Extra protection with customized add-ons", false, true, true],
              ].map(
                ([feature, thirdParty, comprehensive, ownDamage], index) => (
                  <tr key={index} className="border border-gray-300">
                    <td className="p-3 border border-gray-300">{feature}</td>
                    <td className="p-3 text-center border border-gray-300">
                      {thirdParty ? "✅" : "❌"}
                    </td>
                    <td className="p-3 text-center border border-gray-300">
                      {comprehensive ? "✅" : "❌"}
                    </td>
                    <td className="p-3 text-center border border-gray-300">
                      {ownDamage ? "✅" : "❌"}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div> */}
 <div className="max-w-7xl mx-auto px-4 py-6">
      {/* Mobile View (Stacked Cards) */}
      <div className="block md:hidden">
        {data.map(([feature, thirdParty, comprehensive, ownDamage], index) => (
          <div
            key={index}
            className="border mb-4 p-4 rounded-lg bg-white shadow-md"
          >
            <h3 className="font-semibold text-gray-800 mb-2">{feature}</h3>
            <div className="flex justify-between border-t py-1">
              <span className="text-gray-600">Third-Party:</span>
              <span>{thirdParty ? "✅" : "❌"}</span>
            </div>
            <div className="flex justify-between border-t py-1">
              <span className="text-gray-600">Comprehensive:</span>
              <span>{comprehensive ? "✅" : "❌"}</span>
            </div>
            <div className="flex justify-between border-t py-1">
              <span className="text-gray-600">Own Damage:</span>
              <span>{ownDamage ? "✅" : "❌"}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop View (Table) */}
      <div className="hidden md:block overflow-x-auto">
        <table className="min-w-[700px] w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100 text-gray-800">
              <th className="p-3 text-left border border-gray-300">Features</th>
              <th className="p-3 text-center border border-gray-300 font-semibold">Third-Party</th>
              <th className="p-3 text-center border border-gray-300 font-semibold">Comprehensive</th>
              <th className="p-3 text-center border border-gray-300 font-semibold">Own Damage</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {data.map(([feature, thirdParty, comprehensive, ownDamage], index) => (
              <tr key={index} className="border border-gray-300">
                <td className="p-3 border border-gray-300">{feature}</td>
                <td className="p-3 text-center border border-gray-300">
                  {thirdParty ? "✅" : "❌"}
                </td>
                <td className="p-3 text-center border border-gray-300">
                  {comprehensive ? "✅" : "❌"}
                </td>
                <td className="p-3 text-center border border-gray-300">
                  {ownDamage ? "✅" : "❌"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
      <div className="bg-gray-200 px-4 py-10">
        <div className="mx-auto max-w-6xl">
          <h2 className="text-2xl md:text-3xl text-center  font-semibold leading-7 text-primary-500">
            Why Do You Need Car Insurance?
          </h2>
          <p className="text-center text-gray-700 text-lg max-w-3xl mx-auto">
            Car insurance is more than just a legal requirement—it’s your
            financial shield against unexpected road mishaps. Here’s why having
            the right policy is essential:
          </p>
          <ul className="mt-16 grid grid-cols-1 gap-6 text-center text-gray-700 md:grid-cols-3">
            {featuresNew.map((feature, index) => (
              <li
                key={index}
                className="rounded-xl bg-white px-6 py-8 shadow-sm hover:shadow-lg transition-shadow duration-300"
              >
                {feature.icon}
                <h3 className="my-3 font-medium">{feature.title}</h3>
                <p className="mt-1.5 text-sm leading-6 text-gray-600">
                  {feature.description}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="container mx-auto p-6 mt-6">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center">
          What’s Protected Under Your Car Insurance?
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center">
          Car insurance is your financial safety net, shielding you from
          unexpected damages and losses. Whether it’s an accident, theft, or a
          natural disaster, the right policy ensures you stay covered without
          financial stress. Here’s what your car insurance takes care of:
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-4">
          {cardsNew.map((card, index) => (
            <div
              key={index}
              className="border rounded-lg shadow-lg p-6 flex flex-col items-center text-center"
            >
              {card.icon}
              <h3 className="text-lg font-semibold mb-2">{card.title}</h3>
              <p className="text-gray-600">{card.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-6 text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
          What’s NOT Covered Under Your Car Insurance?
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2">
          While car insurance offers a financial safety net, it’s important to
          know its limitations to avoid surprises when filing a claim. Here are
          scenarios where your insurance may not come to the rescue:
        </p>

        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">❌</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Own Damages Under Third-Party Policy
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              A third-party-only policy won’t cover any damages to your own car.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl"> 🍻 </span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Drunk Driving or No License
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              If you’re caught driving under the influence or without a valid
              license, your claim won’t be entertained.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl"> 🚦</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Unlawful Driving
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              Driving with an invalid or learner’s license without a supervisor
              can lead to claim rejection.
            </p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">⚠</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Consequential Damages
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              If your car suffers further damage due to improper handling after
              an accident, it won’t be covered.
            </p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl"> 🌊</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Negligence in Extreme Conditions
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              Driving your car through floods or hazardous conditions against
              manufacturer recommendations may result in claim denial.
            </p>
          </div>
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl"> ➕</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Add-Ons Not Purchased
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              If you haven’t opted for specific add-ons like zero depreciation
              or roadside assistance, those benefits won’t be covered.
            </p>
          </div>
        </div>
      </div>

      <div className=" px-2 md:px-6 bg-gray-100 py-6">
        <div className=" p-6 min-h-screen">
          <h1 className="text-2xl md:text-3xl font-bold text-blue-700 ">
            Key Factors to Consider While Buying Car Insurance Online 🚗💡
          </h1>
          <p className="text-gray-700 mb-6">
            Choosing the right car insurance plan ensures financial security and
            peace of mind. Here are some crucial aspects to check before making
            your purchase:
          </p>

          {points.map((point, index) => (
            <div
              key={index}
              className="mb-2 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h1 className="text-2xl md:text-3xl font-bold text-blue-700 mb-4">
            Key Factors That Affect Car Insurance Premium 🚗💰
          </h1>
          <p className="text-gray-700 mb-6">
            The premium of your car insurance depends on several crucial
            factors. Understanding these can help you make an informed decision
            and optimize your policy costs.
          </p>

          {points2.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
      {/* FAQ section */}
      <div className="max-w-4xl mx-auto py-6">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default CarInsuranceNew;
